import { render, staticRenderFns } from "./CalligraphyCanvas.vue?vue&type=template&id=3555c1c8&scoped=true"
import script from "./CalligraphyCanvas.vue?vue&type=script&lang=js"
export * from "./CalligraphyCanvas.vue?vue&type=script&lang=js"
import style0 from "./CalligraphyCanvas.vue?vue&type=style&index=0&id=3555c1c8&prod&lang=css"
import style1 from "./CalligraphyCanvas.vue?vue&type=style&index=1&id=3555c1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3555c1c8",
  null
  
)

export default component.exports